// extracted by mini-css-extract-plugin
export default {"container":"StripeCreditCardForm_container__0qSNM","heading2Text":"StripeCreditCardForm_heading2Text__8yhX1","hidden":"StripeCreditCardForm_hidden__R3WbO"};